import InvestmentsSection from './InvestmentsSection';

export default InvestmentsSection;
